namespace $ {

	$mol_test_mocks.push( $ => {
		$.$mol_after_timeout = $mol_after_mock_timeout as any as typeof $mol_after_timeout
	})

}
